import { Integration_Handler_Names_Enum } from '@main/graphql/types.generated';
import { z } from 'zod/v4';

import { IntegrationConfig } from '../../../../../../lib';
import { RdsService } from '../../service';

export type MultiAzConfig = typeof MultiAzConfig._.Config;

export const MultiAzConfig = IntegrationConfig.make({
  service: RdsService,
  name: Integration_Handler_Names_Enum.MultiAz,
  configSchema: z.object({
    dbClusterIds: z.array(z.string().min(1)).optional(),
    dbInstanceIds: z.array(z.string().min(1)).optional(),
  }),
});
